import { useState } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { getLabel, getLanguage } from "../../tools/Dictionary";

const ProcessDesignerSchemaAdd = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const StepTemplate = props.StepTemplate;
  const ParentId = props.ParentId;
  const GroupId = props.GroupId;
  const OnClickAddFromTemplate = props.OnClickAddFromTemplate;
  const OnCloseModal = props.OnCloseModal;
  const OnClickSelectMultiple = props.OnClickSelectMultiple;
  const OnClickExternalCopy = props.OnClickExternalCopy;


  //State
  const [loading] = useState(false);
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  const onClickSelectMultiple = () => {

    OnClickSelectMultiple(ParentId, GroupId);
    OnCloseModal();
  };
  
  const onClickExternalCopy = () => {

    OnClickExternalCopy(ParentId);
    OnCloseModal();

  };

  const onClickContext = (e) =>
  {
    e.stopPropagation();
  };


  return (
    <div className="page_modal_background" onContextMenu={onClickContext}>
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ProcessDesignerItem", "Add Step")}
        </div>
        <div className="page_modal_body_cont">
          <div className="processdesigner_schema_add_title" style={{fontWeight: "normal"}}>
            {getLabel("ProcessDesignerSchema", "Please select a template...")}
          </div>
          <div className="processdesigner_schema_add_title">
            {getLabel("ProcessDesignerSchema", "Step Templates")}
          </div>
          <div className="processdesigner_schema_add_section">
            {StepTemplate.map((s, index) => (
              <div className="processdesigner_schema_add_item" key={index} onClick={() => OnClickAddFromTemplate(s)}> 
                <div className="processdesigner_schema_add_item_title">
                  {s.title}
                </div>
                <div className="processdesigner_schema_add_item_description">
                  {s.label[getLanguage().code] || s.label["EN"] || ""}
                </div>
              </div>
            ))}
          </div>
          <div className="processdesigner_schema_add_title">
            {getLabel("ProcessDesignerSchema", "Existing Steps")}
          </div>
          <div className="processdesigner_schema_add_section">
            <div className="processdesigner_schema_add_item" onClick={() => onClickSelectMultiple()}>
              <div className="processdesigner_schema_add_item_title">
                {getLabel("ProcessDesignerSchema", "Select Multiple")}
              </div>
              <div className="processdesigner_schema_add_item_description">
                {getLabel("ProcessDesignerSchema", "Select multiple steps in this process to copy")}
              </div>
            </div>  
            <div className="processdesigner_schema_add_item" onClick={() => onClickExternalCopy()}>
              <div className="processdesigner_schema_add_item_title">
                {getLabel("ProcessDesigner", "External Copy")}
              </div>
              <div className="processdesigner_schema_add_item_description">
                {getLabel("ProcessDesigner", "Copy steps from another process")}
              </div>
            </div>           
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default ProcessDesignerSchemaAdd